$(() => {
  if ($('trix-editor').length > 0) {
    import('trix');
  }
});
